import React from 'react';
import MediaCenterContent from '../../MediaCenterContent';
import { useBagContext } from '../../../../../../../services/bag';
import { MediaCenterController } from '../../../../../../../hooks/useMediaCenterController';
import {
  CREATE_FILE,
  LIST_FILES,
  UPDATE_FILE,
  DELETE_FILE,
} from '../../graphql';
import { useTranslation } from 'react-i18next';

export default function MediaCenterSlider(): JSX.Element {
  const { media } = useBagContext<MediaCenterController>();
  const { t } = useTranslation('mediaCenter');
  const type = 'image';

  return (
    <MediaCenterContent
      deleteGql={DELETE_FILE}
      refetchQuery={LIST_FILES}
      updateGql={UPDATE_FILE}
      createGql={CREATE_FILE}
      type={type}
      acceptFiles="image/*"
      filesDescription={t('Image Files')}
      {...media}
    />
  );
}
